export const DASHBOARD_FY_OPTIONS = ["FY 2024-25", "FY 2025-26", "FY 2026-27"];
export const ALL_YEARS_OPTION = "All Years";

export function normalizeFySelection(value, availableOptions = DASHBOARD_FY_OPTIONS) {
  const rawValues = Array.isArray(value)
    ? value.flatMap((item) => String(item).split(","))
    : String(value || "").split(",");

  const cleaned = rawValues.map((item) => item.trim()).filter(Boolean);
  const includesAllYears = cleaned.includes(ALL_YEARS_OPTION);
  if (includesAllYears) return [...availableOptions];

  const unique = [];
  availableOptions.forEach((option) => {
    if (cleaned.includes(option) && !unique.includes(option)) {
      unique.push(option);
    }
  });
  return unique;
}

export function getDefaultFySelection(availableOptions = DASHBOARD_FY_OPTIONS) {
  return ["FY 2025-26"];
}

export function isAllFySelected(selection, availableOptions = DASHBOARD_FY_OPTIONS) {
  const normalized = normalizeFySelection(selection, availableOptions);
  return normalized.length === availableOptions.length;
}

export function serializeFyForApi(selection, availableOptions = DASHBOARD_FY_OPTIONS) {
  const normalized = normalizeFySelection(selection, availableOptions);
  // When all FYs selected, send no filter so backend returns ALL grants
  if (normalized.length === availableOptions.length) return undefined;
  return normalized.length ? normalized.join(",") : undefined;
}

export function buildDashboardParams(filters, extra = {}, availableOptions = DASHBOARD_FY_OPTIONS) {
  return {
    fy: serializeFyForApi(filters.fy, availableOptions),
    theme: filters.theme || undefined,
    trust: filters.trust || undefined,
    status: filters.status || undefined,
    grantee: filters.grantee || undefined,
    ...extra,
  };
}

export function appendFyToSearchParams(searchParams, selection, availableOptions = DASHBOARD_FY_OPTIONS) {
  const serialized = serializeFyForApi(selection, availableOptions);
  if (serialized) searchParams.append("fy", serialized);
}

export function getFyButtonLabel(selection, availableOptions = DASHBOARD_FY_OPTIONS) {
  const normalized = normalizeFySelection(selection, availableOptions);
  if (!normalized.length || normalized.length === availableOptions.length) return ALL_YEARS_OPTION;
  if (normalized.length === 1) return normalized[0];
  return `${normalized.length} FYs selected`;
}
